import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

// Analytics
import { OutboundLink } from 'react-ga';

// Reducers
import { clearSearchResults } from '../../reducers/searchReducer';

class Footer extends React.Component {
	constructor(props) {
		super(props);

		this.state = { showMarquee: false };

		// This binding is necessary to make `this` work in the callback
		this.handleClick = this.handleClick.bind(this);
		this.clearSearch = this.clearSearch.bind(this);
	}

	handleClick() {
		this.setState(prevState => ({ showMarquee: !prevState.showMarquee }));
	}

	clearSearch() {
		this.props.dispatch(clearSearchResults());
		this.setState({ hasSearch: false });
	}

	shouldComponentUpdate(nextProps, nextState) {
		// This prevents needless renders. It will render on page change though because we embed the footer into each page instead of the index.
		return this.state.showMarquee !== nextState.showMarquee;
	}

	render() {
		const springOvum = window.atob && atob('TG92aW5nbHkgd3JpdHRlbiBieSBTaGF3biBIb2ZmbWFuIGFuZCBSb2JlcnQgUG9ydGVyLiBJbnNwaXJlZCBieSBMZXZpIFdvbGZlLiBVbmRlciB0aGUgbGVhZGVyc2hpcCBvZiBTdGV2ZSBIZXltYW4uIFNwZWNpYWwgVGhhbmtzIHRvIERhdmUgQnJvd24sIHdoZXJldmVyIHlvdSBhcmUu');

		return (
			<footer>
				<p>
					<span onClick={this.handleClick}>©</span>
					&nbsp;{new Date().getFullYear()}
					<OutboundLink
						eventLabel="Outbound - Blog"
						to="http://dynamicsignal.com"
						rel="noopener noreferrer">
						Dynamic Signal Inc.
					</OutboundLink> All rights reserved.
				</p>
				<p className="marquee" style={{ display: this.state.showMarquee ? null : 'none' }}>
					{springOvum}
				</p>
				<ul>
					<li>
						<NavLink to="/changelog" onClick={this.clearSearch}>Changelog</NavLink>
					</li>
					<li>
						<OutboundLink
							eventLabel="Outbound - Blog"
							to="http://dynamicsignal.com/blog/"
							rel="noopener noreferrer">
							Blog
						</OutboundLink>
					</li>
					<li>
						<OutboundLink
							eventLabel="Outbound - Contact Us"
							to="http://dynamicsignal.com/contact-us/"
							rel="noopener noreferrer">
							Contact Us
						</OutboundLink>
					</li>
					<li>
						<OutboundLink
							eventLabel="Outboung - Github"
							to="https://github.com/DynamicSignal"
							rel="noopener noreferrer">
							<i className="fa fa-github" style={{ fontSize: '2em' }} aria-hidden="true"></i>
						</OutboundLink>
					</li>
				</ul>
			</footer>
		);
	}
}

Footer.propTypes = {
	dispatch: PropTypes.func
};

export default withRouter(connect()(Footer));


// WEBPACK FOOTER //
// ./src/components/shared/Footer.js